import { Workbox } from "workbox-window";

// Request persistent storage so iOS/WebKit won't evict localStorage & IndexedDB
if (navigator.storage && navigator.storage.persist) {
	navigator.storage.persist()
		.then(granted => {
			console.log(`[Storage] Persistent storage ${granted ? "granted" : "denied"}`);
		})
		.catch(err => {
			console.warn("[Storage] Could not request persistent storage:", err);
		});
}

if ("serviceWorker" in navigator) {
	const wb = new Workbox(`${process.env.BASE_URL}service-worker.js`);

	let updatePending = false;

	wb.addEventListener("installed", (event) => {
		if (event.isUpdate) {
			console.log("[SW] New version installed, waiting to activate");
		} else {
			console.log("[SW] Service worker installed for the first time");
		}
	});

	wb.addEventListener("waiting", () => {
		updatePending = true;

		// When embedding the widget or microsite, auto-update without asking
		if (/(widget|microsite)/.test(window.location.href)) {
			wb.messageSkipWaiting();
			return;
		}

		// Emit a custom event for the app to handle the UI
		window.dispatchEvent(
			new CustomEvent("sw-update-available", {
				detail: { skipWaiting: () => wb.messageSkipWaiting() }
			})
		);
	});

	wb.addEventListener("controlling", () => {
		if (updatePending) {
			window.location.reload();
		}
	});

	wb.addEventListener("redundant", () => {
		console.warn("[SW] Service worker became redundant");
	});

	wb.register().catch((err) => {
		console.error("[SW] Service worker registration failed:", err);
	});

	// Check for updates when tab becomes visible
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "visible") {
			wb.update().catch(() => {});
		}
	});
}
